<!-- <app-top-promo [isMobile]="isMobile"></app-top-promo> -->
<div class="homePage">

    <app-header [isMobile]="isMobile" [isHome]="isHome"></app-header>
    <div class="headerSpacer"></div>

    <app-home-slider [data]="data" [isMobile]="isMobile"></app-home-slider>

    <div class="homeContent">

        <!-- Spotlight -->
        <div class="homeSection spotlightSection">
            <div class="sectionHeader">
                <div class="sectionTitleLeft">Spotlight</div>
            </div>
            <div class="sectionDivider"></div>
            <div class="promoGrid">
                <a href="https://lionsgateplus.com/" target="_blank" class="homePromo">
                    <img src="assets/img/home-v2/lionsgate-plus-promo.jpg" alt="Lionsgate+">
                    <div class="border"></div>
                </a>
                <a href="https://moviesphereplus.com/" target="_blank" class="homePromo">
                    <img src="assets/img/home-v2/moviesphere-plus-promo.jpg" alt="MovieSphere+">
                    <div class="border"></div>
                </a>
                <a href="https://moviespheregold.com/" target="_blank" class="homePromo">
                    <img src="assets/img/home-v2/moviesphere-gold-promo.jpg" alt="MovieSphere Gold">
                    <div class="border"></div>
                </a>
                <a href="https://50centaction.com" target="_blank" class="homePromo">
                    <img src="assets/img/home-v2/50-cent-action-promo.jpg" alt="50 Cent Action">
                    <div class="border"></div>
                </a>
            </div>
        </div>

    </div>

    <app-home-show-list [data]="data" [isMobile]="isMobile"></app-home-show-list>

    <app-footer [isInverted]="true"></app-footer>
</div>

<div class="sizzleBg" [ngClass]="{open: pageDataService.isOverlayOpen}"></div>
<app-sizzle-overlay></app-sizzle-overlay>
